@switch (type()) {
  @case ("status") {
    @if (!!contract()) {
      <div class="flex items-center gap-1.5 text-lg text-gray-2">
        @switch (contract().status) {
          @case (contractStatus.Active) {
            <div class="flex items-center justify-start gap-2">
              <div class="flex items-center">
                <mat-icon
                  [ngClass]="policyTerms() > 30 ? 'text-green-success' : 'text-orange-warning'"
                  [fontIcon]="policyTerms() > 30 ? 'gpp_good' : 'gpp_maybe'"
                ></mat-icon>
                <shared-info-badge
                  [text]="'status.contract.Active' + (policyTerms() > 30 ? '' : 'Ending') | translate"
                  [color]="policyTerms() > 30 ? badgeColors.Green : badgeColors.Orange"
                  [rounded]="false"
                ></shared-info-badge>
              </div>
              <p>
                {{ "context.label.client.policyTerm" | translate: { policyTerm: policyTerms() } }}
              </p>
            </div>
          }
          @case (contractStatus.Inactive) {
            <div class="flex items-center justify-start gap-2">
              <div class="flex items-center justify-start gap-2">
                <mat-icon
                  class="text-blue-primary"
                  [fontIcon]="'ac_unit'"
                ></mat-icon>
                <shared-info-badge
                  [text]="'status.contract.' + contract().status | translate"
                  [color]="badgeColors.Blue"
                  [rounded]="false"
                ></shared-info-badge>
              </div>
              <p>{{ "status.contract.inactive.label" | translate }}</p>
            </div>
          }
          @case (contractStatus.Draft) {
            <div class="flex items-center justify-start gap-2">
              <div class="flex items-center justify-start gap-2">
                <mat-icon
                  class="text-orange-warning"
                  [fontIcon]="'report_problem'"
                ></mat-icon>
                <shared-info-badge
                  [text]="'status.contract.' + contract().status | translate"
                  [color]="badgeColors.Orange"
                  [rounded]="false"
                ></shared-info-badge>
              </div>
              <p>{{ "status.contract.draft.label" | translate }}</p>
            </div>
          }
          @case (contractStatus.Rejected) {
            <div class="flex items-center justify-start gap-2">
              <div class="flex items-center justify-start gap-2">
                <mat-icon
                  class="text-red-error-dark"
                  [fontIcon]="'gpp_bad'"
                ></mat-icon>
                <shared-info-badge
                  [text]="'status.contract.' + contract().status | translate"
                  [color]="badgeColors.Red"
                  [rounded]="false"
                ></shared-info-badge>
              </div>
              <p>{{ "status.contract.rejected.label" | translate }}</p>
            </div>
          }
          @case (contractStatus.Expired) {
            <div class="flex items-center justify-start gap-2">
              <div class="flex items-center justify-start gap-2">
                <mat-icon
                  class="text-red-error-dark"
                  [fontIcon]="'gpp_bad'"
                ></mat-icon>
                <shared-info-badge
                  [text]="'status.contract.' + contract().status | translate"
                  [color]="badgeColors.Red"
                  [rounded]="false"
                ></shared-info-badge>
              </div>
              <p>{{ "status.contract.expired.label" | translate }}</p>
            </div>
          }
          @case (contractStatus.Signed) {
            <div class="flex items-center justify-start gap-2">
              <div class="flex items-center justify-start gap-2">
                <mat-icon
                  class="text-orange-warning"
                  [fontIcon]="'report_problem'"
                ></mat-icon>
                <shared-info-badge
                  [text]="'status.contract.' + contract().status | translate"
                  [color]="badgeColors.Orange"
                  [rounded]="false"
                ></shared-info-badge>
              </div>
              <p>{{ "status.contract.draft.label" | translate }}</p>
            </div>
          }
        }
      </div>
    } @else {
      <div class="flex items-center justify-start gap-2">
        <mat-icon
          class="text-red-error-dark"
          [fontIcon]="'gpp_bad'"
        ></mat-icon>
        <p>{{ "context.label.contract.noContracts" | translate }}</p>
      </div>
    }
  }
  @case ("list-items") {
    @if (!!contracts().length) {
      @for (contract of contracts(); track $index) {
        @if (showFullContractsList() || defaultContracts().includes(contract)) {
          <div class="flex w-full min-w-[540px] items-center gap-4 text-nowrap">
            <div class="flex items-center gap-0.5">
              @if (contract.status) {
                <div class="h-6 w-6">
                  @switch (contract.status) {
                    @case (contractStatus.Active) {
                      <mat-icon
                        [ngClass]="calculatePolicyTerms(contract) > 30 ? 'text-green-success' : 'text-orange-warning'"
                        [fontIcon]="calculatePolicyTerms(contract) > 30 ? 'gpp_good' : 'gpp_maybe'"
                      ></mat-icon>
                    }
                    @case (contractStatus.Inactive) {
                      <mat-icon
                        class="text-blue-primary"
                        [fontIcon]="'ac_unit'"
                      ></mat-icon>
                    }
                    @case (contractStatus.Draft) {
                      <mat-icon
                        class="text-orange-warning"
                        [fontIcon]="'report_problem'"
                      ></mat-icon>
                    }
                    @case (contractStatus.Signed) {
                      <mat-icon
                        class="text-orange-warning"
                        [fontIcon]="'report_problem'"
                      ></mat-icon>
                    }
                    @case (contractStatus.Rejected) {
                      <mat-icon
                        class="text-red-error-dark"
                        [matTooltip]="'Деактивовано: ' + formatDate(contract.deactivatedAt)"
                        [fontIcon]="'gpp_bad'"
                      ></mat-icon>
                    }
                    @case (contractStatus.Expired) {
                      <mat-icon
                        class="text-red-error-dark"
                        [matTooltip]="'Деактивовано: ' + formatDate(contract.deactivatedAt)"
                        [fontIcon]="'gpp_bad'"
                      ></mat-icon>
                    }
                  }
                </div>
              }

              <span class="mr-1 text-gray-2">{{ "context.label.contract.policyNumber" | translate }}</span>
              <span class="text-black">{{ formatPolicyNumber(contract.contractNumber) }}</span>
              @if (contract.clientType) {
                <shared-info-badge
                  [text]="contract.clientType"
                  [color]="badgeColors.Blue"
                  [withBorder]="false"
                >
                </shared-info-badge>
              }
            </div>
            <div class="flex items-center gap-1">
              @if (contract.activeFrom) {
                <span class="text-gray-2">{{ "context.label.contract.terms" | translate }}</span>
                <span class="text-black">{{ formatDate(contract.activeFrom) + " - " + formatDate(contract.activeTo) }}</span>
              }
              @if (!!contract.inactiveAt && datesCompare(contract.inactiveAt, todayDate)) {
                <span class="flex text-xl text-gray-2">
                  <mat-icon [matTooltip]="'Очікує деактивації: ' + formatDate(contract.inactiveAt)"> update </mat-icon>
                </span>
              }
            </div>
          </div>
        }
      }

      @if (contracts().length > defaultContracts().length) {
        <button
          class="flex items-center justify-start text-sm font-normal text-gray-1"
          [type]="'button'"
          (click)="toggleExpandedList()"
        >
          {{ (!showFullContractsList() ? "buttons.showMore" : "buttons.hide") | translate }}
          <mat-icon class="mb-1 text-lg">{{ !showFullContractsList() ? "expand_more" : "expand_less" }}</mat-icon>
        </button>
      }
    } @else {
      <span class="text-black">{{ "context.label.contract.notFind" | translate }}</span>
    }
  }
}
